export default "__VITE_ASSET__Co1CU8pl__"